import { Component, OnInit, Inject, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AsComponent, AsConfigService } from '../../../../shared/external-libraries/ngx-advanced-searchbox/src/public_api';
import { FormGroup } from '@angular/forms';
import { LooseObject } from '../../../../objects/loose-object';
import { ListingService } from '../../../../services/listing.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SearchService } from '../../../../services/search.service';
import { RecordService } from '../../../../services/record.service';
import { NotificationService } from '../../../../services/notification.service';
import { cloneDeep, get } from 'lodash-es';
import { of, Subject, Subscription } from 'rxjs';
import { SearchAfter } from '../../../../objects/elasticsearch';
import { blank, filled } from '../../../../shared/utils/common';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import CommonPaginationConfig from '../../../../shared/components/listing/common/pagination/common-pagination.component';
import { AdvanceSearchboxTemplate } from '../../../../objects/advance-searchbox';
import { Relate } from '../../../../objects/relate';
import { Select } from '../../../../objects/select';
import { FormService } from '../../../../services/form.service';
import { JsonService } from '../../../../services/helpers/json/json.service';
import moment from 'moment';
import { ChecklistsService } from '../../../../services/checklist.service';
import { sprintf } from 'sprintf-js';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contract-recurring-jobs-asset-types',
  templateUrl: './asset-types.component.html',
  styleUrls: ['./asset-types.component.scss'],
})
export class ContractRecurringJobsAssetTypeComponent implements OnInit {

  @ViewChild(AsComponent) advancedSearchboxComponent: AsComponent;

  @HostListener('window:keyup.esc') onKeyUp() {
    this.closeDialog();
  }

  objAdvancedSearchbox: {
    model?: object
    template?: Array<object>
    form?: FormGroup
  } = {};

  arModel = {};

  arRowDisplay: [][] = [];

  arData: LooseObject[] = [];

  arSelectedRecords: LooseObject = {};

  arSubscriptions: Subscription[] = [];

  arRecordsToLink: LooseObject = {};

  bSubmitted: boolean = false;

  arSearchAfters: SearchAfter[] = [];

  objLegends: LooseObject = {};

  objPagination: LooseObject = {};

  objSite = new Relate<Select[]>();

  objNextJobDate;

  objSelectedChecklist: LooseObject = {};

  strSiteId: string = '';

  strCustomerId: string = '';

  strContractId: string = '';

  strSearchTerm: string = '';

  objSearchTerm$ = new Subject<string>();

  selectAllAssetType: boolean = false;

  constructor(
    public listingService: ListingService,
    private dialogRef: MatDialogRef<ContractRecurringJobsAssetTypeComponent>,
    private router: Router,
    private asConfigService: AsConfigService,
    private searchService: SearchService,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private recordService: RecordService,
    private notificationService: NotificationService,
    private formService: FormService,
    private jsonService: JsonService,
    private checklistService: ChecklistsService,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
  }

  ngOnInit() {
    this.initFields();
    this._getAssetInspectionChecklist();
  }

  initFields(): void {
    this.objNextJobDate = moment().add(1, 'M').startOf('month');
    this.strSiteId = get(this.data, 'site_id');
    this.strCustomerId = get(this.data, 'customer_id');
    this.strContractId = get(this.data, 'contract_id');

    let objDefaultValues = [];
    let objRelateFilter: LooseObject = {};
    let strModule: string = filled(this.strContractId) ? 'contract_sites' : 'sites';

    if (filled(this.strSiteId)) {
      objDefaultValues.push(new Select(
        get(this.data, 'record_details.id'),
        get(this.data, 'record_details.text')
      ));
    } else if (this.strCustomerId) {
      objRelateFilter = {
        customer_id: this.strCustomerId
      };
    } else if (this.strContractId) {
      objRelateFilter = {
        type: 'sites',
        contract_id: this.strContractId,
      }
    }

    this.objSite.buildRelates(
      switchMap(strTerm => {
        if (strModule == 'sites') {
          objRelateFilter = blank(strTerm) && filled(this.strCustomerId) ? {
            customer_id: this.strCustomerId
          } : {};
        }
        return this.recordService.getRecordRelate(
          strModule,
          strTerm,
          false,
          false,
          objRelateFilter
        )
      }),
      objDefaultValues,
      filled(objDefaultValues)
    );

    this.objSearchTerm$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
    ).subscribe( () => this._getAssetInspectionChecklist(1) );
  }

  closeDialog(response: LooseObject = {}): void {
    this.dialogRef.close(response);
  }

  /**
   * This method forces a change detect. This is useful
   * so we can re-use the proceess triggered on
   * change detect.
   *
   * @returns {void}
   */
  forceComponentChanges(): void {
    this.changeDetectorRef.detectChanges();
  }

  /**
   * when asset type checklist checkbox is changed
   *
   * @param event
   * @param data
   */
  onChangeCheckbox(event: Event, data: LooseObject): void {
    let strSelectedId = get(data, 'id', '');
    data.is_checked = event.currentTarget['checked'];
    data.repeating_group.map( repeatingGroup => {
      repeatingGroup.is_checked = data.is_checked;
      return repeatingGroup;
    });

    if (event.currentTarget['checked'] == true) {
      this.objSelectedChecklist[strSelectedId] = data;
    } else {
      delete this.objSelectedChecklist[strSelectedId];
    }

    this._isAllRecordSelected();
  }

  /**
   * when repeating group checkbox is changed
   *
   * @param event
   * @param checklist
   * @param repeatingGroup
   */
  onChangeCheckboxRepeatingGroup(event: Event, checklist: LooseObject, repeatingGroup: LooseObject): void {
    let strSelectedId = get(checklist, 'id', '');
    let arRepeatingGroup = get(checklist, 'repeating_group');

    repeatingGroup.is_checked = event.currentTarget['checked'];
    if (filled(arRepeatingGroup)) {
      checklist.is_checked = filled(arRepeatingGroup.filter( data => data.is_checked == true));
    }

    if (
      checklist.is_checked
      && filled(get(this.objSelectedChecklist, checklist.id))
      && filled(get(this.objSelectedChecklist[checklist.id], 'repeating_group'))
    ) {
      let intRepeating = this.objSelectedChecklist[checklist.id].repeating_group.findIndex(data => data.id == repeatingGroup.id);
      if (intRepeating > -1) {
        this.objSelectedChecklist[checklist.id].repeating_group[intRepeating].is_checked = event.currentTarget['checked']
      }
    }

    if (checklist.is_checked == false) {
      delete this.objSelectedChecklist[strSelectedId];
    }

    this._isAllRecordSelected();
  }

  onChangePage(page: any): void {
    if (page == 'default') {
      this._getAssetInspectionChecklist(1);
    } else if (page == 'next') {
      this._getAssetInspectionChecklist(this.objPagination.currentPage+1);
    } else if (page == 'prev') {
      this._getAssetInspectionChecklist(this.objPagination.currentPage-1);
    } else {
      this._getAssetInspectionChecklist(page);
    }
  }

  onChangeSearch(event): void {
    this.objSearchTerm$.next(event);
  }

  onClearSearch(): void {
    this.strSearchTerm = '';
    this.objSearchTerm$.next('');
  }

  addRecord(): void {
    if (blank(this.objSite.value)) {
      this.notificationService.sendConfirmation('no_site_selected_confirm').pipe(
        filter( confirm => confirm.answer == true)
      ).subscribe(() => this.closeDialog({
        sites: null,
        checklists: this.objSelectedChecklist,
        next_job_date: this.objNextJobDate.format('YYYY-MM-DD')
      }));
    } else {
      this.closeDialog({
        sites: this.objSite.value,
        checklists: this.objSelectedChecklist,
        next_job_date: this.objNextJobDate.format('YYYY-MM-DD')
      })
    }
  }

  onChangeCheckboxAll(event: Event): void {
    this.arData.forEach( data => {
      if (data.has_valid_group == true && filled(data.repeating_group)) {
        this.onChangeCheckbox(event, data);
      }
    })
  }

  private _getAssetInspectionChecklist(pageNum: number = 0): void {
    this.listingService.bLoading = true;
      this.checklistService.getAssetInspectionChecklist(this.strSearchTerm, pageNum).subscribe( response => {
        this.arData = response['data'].map( data => {
          data.questions = this.jsonService.parse(data.questions);
          data.repeating_group = this._getRepeatingGroup(data);
          data['is_checked'] = filled(get(this.objSelectedChecklist, data.id));
          data['has_valid_group'] = filled(data.repeating_group);

          return data;
        });

        this._isAllRecordSelected();

        this.objPagination = new CommonPaginationConfig({
          hasNextPage: response.current_page < response.last_page,
          hasPrevPage: response.current_page != 1,
          currentPage: response.current_page,
          totalPage: response.last_page,
          hasNavigation: true
        });

        this.listingService.bLoading = false;
      });
  }

  /**
   * get the questions repeating group
   *
   * @param checklist
   * @returns
   */
  private _getRepeatingGroup(checklist: LooseObject): LooseObject[] {
    let arChecklistInspection = []
    let arQuestions = get(checklist, 'questions');
    let objSelectedChecklist = get(this.objSelectedChecklist, checklist.id);
    let arSelectedGroup = [];

    if (filled(objSelectedChecklist)) {
      arSelectedGroup = this.objSelectedChecklist[checklist.id].repeating_group
    }

    arQuestions.forEach( question => {
      question.prompts.forEach( prompt => {
        let strPeriod = get(prompt, 'available_period');
        let bValidPeriod = /^\d+/.test(strPeriod);
        if (prompt.is_group && bValidPeriod) {

          arChecklistInspection.push({
            id: prompt.id,
            is_checked: arSelectedGroup.findIndex( group => group.is_checked && group.id == prompt.id) > -1,
            asset_type_id: get(checklist, 'asset_type_id'),
            repeated_every: prompt.available_period,
            prompt_name: sprintf('%s (%s)', prompt.group_name, this._translatePeriod(prompt.available_period)),
            period: this._translatePeriod(prompt.available_period),
          });
        }
      });
    });

    return arChecklistInspection;
  }

  /**
   * translate period
   *
   * @param period
   *
   * @returns
   */
  private _translatePeriod(period): string {
    const arPeriod = period.split('_');
    let strTranslatedPeriod = period;
    if (filled(arPeriod[1]) && typeof arPeriod[1] === 'string') {

      strTranslatedPeriod = sprintf('%s %s', arPeriod[0], this.translateService.instant(arPeriod[1]));
    }

    return strTranslatedPeriod;
  }

  /**
   * to determine if we need to check the selected all input
   */
  private _isAllRecordSelected(): void {
    this.selectAllAssetType = blank(cloneDeep(this.arData).filter( data =>
      data.has_valid_group == true && data.is_checked == false
    ));
  }
}
